import React from 'react'
import styles from './TrustRow.module.css'

/* RecommendedPlan's trustRow — tagPill + three icon items. */
const TrustRow = () => (
  <>
    {/* RecommendedPlan's capFooter tagPill */}
    {/* <div className={styles.tagPill}>
      <span className={styles.tagDot} />
      All-in-one
      <span className={styles.tagDot} />
      Always on
      <span className={styles.tagDot} />
      Built for your business
    </div> */}

    <div className={styles.trustRow}>
    <div className={styles.trustItem}>
      <span className={`${styles.trustBadge} ${styles.trustBadgeYellow}`}>
        <img src="/svg/rating_icon.svg" alt="rating_icon" />
      </span>
      <div>
        <p className={styles.trustTitle}>4.9/5 from</p>
        <p className={styles.trustSub}>136 Business</p>
      </div>
    </div>

    <div className={styles.trustItem}>
      <span className={styles.trustBadge}>
        <img src="/svg/security_icon.svg" alt="security_icon" />
      </span>
      <div>
        <p className={styles.trustTitle}>Bank-level</p>
        <p className={styles.trustSub}>Security</p>
      </div>
    </div>

    <div className={styles.trustItem}>
      <span className={styles.trustBadge}>
        <img src="/svg/fee_icon.svg" alt="fee_icon" />
      </span>
      <div>
        <p className={styles.trustTitle}>No hidden fees</p>
        <p className={styles.trustSub}>Transparent policy</p>
      </div>
    </div>
    </div>
  </>
)

export default TrustRow
